import { Col, Row } from "react-bootstrap";

export const ECG12LeadSection = (props: {
    ecg: any,
}) => {
    return (
        <>
            <Row>
                <Col>
                    <strong>Date</strong>:
                </Col>
            </Row>
            <Row>
                <Col>
                    <pre>{props.ecg.result_time}</pre>
                </Col>
            </Row>
            <Row>
                <Col>
                    <strong>Impression</strong>:
                </Col>
            </Row>
            <Row>
                <Col>
                    <pre>{props.ecg.impression}</pre>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            HR: <strong>{props.ecg.measurements["HEART RATE"]}</strong>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            QTc: <strong>{props.ecg.measurements["QTC INTERVAL"]}</strong>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            T_axis: <strong>{props.ecg.measurements["T WAVE AXIS"]}</strong>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row>
                        <Col>
                            PR: <strong>{props.ecg.measurements["P-R INTERVAL"]}</strong>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            P_axis: <strong>{props.ecg.measurements["P AXIS"]}</strong>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row>
                        <Col>
                            QRS: <strong>{props.ecg.measurements["QRSD INTERVAL"]}</strong>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            QRS_axis: <strong>{props.ecg.measurements["QRS AXIS"]}</strong>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};
